import { Button, Flex, useStyles } from '@archipro-design/aria';
import { CheckboxBlankLine, CheckboxFill } from '@archipro-design/icons';
import type {
    FilterBarCheckboxFilter,
    FilterState,
    FilterStatesKey,
} from '../../type/filter-state';

import * as S from './FilterBarFilters.style';

interface FilterBarFiltersProps {
    filters: FilterBarCheckboxFilter[];
    updateFilter: (
        filterKey: FilterStatesKey,
        state: Partial<FilterState>
    ) => void;
}

const FilterBarFilters = ({ filters, updateFilter }: FilterBarFiltersProps) => {
    const { css } = useStyles();
    return (
        <Flex className={css(S.FilterBarFiltersWrapper)}>
            {filters.map(
                ({ filterKey, label, checked, disabled, props, newState }) => (
                    <Button
                        key={filterKey}
                        variant="text"
                        size={18}
                        variables={{ buttonPadding: 0, iconPadding: 0 }}
                        iconBefore={
                            checked ? <CheckboxFill /> : <CheckboxBlankLine />
                        }
                        disabled={disabled}
                        onClick={() => {
                            updateFilter(filterKey, newState);
                        }}
                        className={props?.className}
                    >
                        {label}
                    </Button>
                )
            )}
        </Flex>
    );
};

export default FilterBarFilters;
